import React, { useState } from 'react';
import { ChatBubbleLeftRightIcon } from '@heroicons/react/24/outline';
import ChatPopup from '../../components/ChatPopup';

const Chat: React.FC = () => {
  const [isChatOpen, setIsChatOpen] = useState(true);

  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-50 via-purple-50 to-blue-50 py-2 sm:py-4 lg:py-6">
      <div className="max-w-4xl mx-auto px-3 sm:px-4 lg:px-6 xl:px-8">
        <div className="bg-white rounded-lg sm:rounded-xl shadow-lg p-4 sm:p-6 lg:p-8 border border-indigo-100 relative overflow-hidden">
          {/* Background decoration */}
          <div className="absolute top-0 right-0 w-16 h-16 sm:w-20 sm:h-20 lg:w-24 lg:h-24 bg-gradient-to-br from-indigo-100 to-purple-100 rounded-full -mr-8 sm:-mr-10 lg:-mr-12 -mt-8 sm:-mt-10 lg:-mt-12 opacity-50"></div>
          <div className="absolute bottom-0 left-0 w-12 h-12 sm:w-16 sm:h-16 lg:w-20 lg:h-20 bg-gradient-to-tr from-purple-50 to-indigo-50 rounded-full -ml-6 sm:-ml-8 lg:-ml-10 -mb-6 sm:-mb-8 lg:-mb-10 opacity-50"></div>
          
          <div className="relative z-10 text-center">
            <div className="flex justify-center mb-3 sm:mb-4 lg:mb-6">
              <div className="bg-gradient-to-r from-indigo-500 to-purple-600 rounded-full p-2 sm:p-3 lg:p-4 shadow-lg transform hover:scale-105 transition-transform duration-200">
                <ChatBubbleLeftRightIcon className="w-6 h-6 sm:w-8 sm:h-8 lg:w-10 lg:h-10 text-white" />
              </div>
            </div>
            
            <h1 className="text-lg sm:text-xl lg:text-2xl xl:text-3xl font-bold text-gray-900 mb-2 sm:mb-3 lg:mb-4">
              ສົ່ງຂໍ້ຄວາມໃຫ້ຄູສອນຂອງທ່ານ
            </h1>
            
            <p className="text-xs sm:text-sm lg:text-base xl:text-lg text-gray-600 mb-4 sm:mb-6 lg:mb-8 leading-relaxed max-w-2xl mx-auto px-2">
              ສົ່ງຂໍ້ຄວາມໃຫ້ຄູສອນຂອງທ່ານແລະຮັບຄວາມຊ່ວຍເຫຼືອໃນການສຶກສາຂອງທ່ານ. ຄູສອນຈະຕອບກັບທ່ານໃນໄວໆນີ້.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-2 sm:gap-3 lg:gap-4 justify-center items-center">
              <button
                onClick={() => setIsChatOpen(true)}
                className="w-full sm:w-auto inline-flex items-center justify-center px-3 sm:px-4 lg:px-6 py-2 sm:py-3 lg:py-4 border border-transparent text-xs sm:text-sm lg:text-base font-semibold rounded-lg sm:rounded-xl text-white bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 shadow-lg transform hover:scale-105 transition-all duration-200"
              >
                <ChatBubbleLeftRightIcon className="w-3 h-3 sm:w-4 sm:h-4 lg:w-5 lg:h-5 mr-1 sm:mr-2" />
                ເປີດການສົນທະນາ
              </button>
              
              <button
                onClick={() => setIsChatOpen(true)}
                className="w-full sm:w-auto inline-flex items-center justify-center px-3 sm:px-4 lg:px-6 py-2 sm:py-3 lg:py-4 border-2 border-gray-200 hover:border-indigo-300 text-xs sm:text-sm lg:text-base font-medium rounded-lg sm:rounded-xl text-gray-700 hover:text-indigo-600 transition-all duration-200"
              >
                <svg className="w-3 h-3 sm:w-4 sm:h-4 lg:w-5 lg:h-5 mr-1 sm:mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
                </svg>
                ສົ່ງຂໍ້ຄວາມໃໝ່
              </button>
            </div>
            
            {/* Additional info section */}
            <div className="mt-6 sm:mt-8 lg:mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4 lg:gap-6">
              <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-lg sm:rounded-xl p-3 sm:p-4 lg:p-5 border border-blue-200">
                <div className="flex items-center mb-2 sm:mb-3">
                  <div className="bg-blue-500 rounded-full p-1.5 sm:p-2 mr-2 sm:mr-3">
                    <svg className="w-3 h-3 sm:w-4 sm:h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                  </div>
                  <h3 className="text-xs sm:text-sm lg:text-base font-semibold text-blue-800">ຕອບກັບໄວ</h3>
                </div>
                <p className="text-xs sm:text-sm text-blue-700">ຄູສອນຈະຕອບກັບທ່ານໃນໄວໆນີ້</p>
              </div>
              
              <div className="bg-gradient-to-r from-green-50 to-emerald-50 rounded-lg sm:rounded-xl p-3 sm:p-4 lg:p-5 border border-green-200">
                <div className="flex items-center mb-2 sm:mb-3">
                  <div className="bg-green-500 rounded-full p-1.5 sm:p-2 mr-2 sm:mr-3">
                    <svg className="w-3 h-3 sm:w-4 sm:h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                  </div>
                  <h3 className="text-xs sm:text-sm lg:text-base font-semibold text-green-800">ຄວາມຊ່ວຍເຫຼືອ</h3>
                </div>
                <p className="text-xs sm:text-sm text-green-700">ຮັບຄວາມຊ່ວຍເຫຼືອໃນການສຶກສາ</p>
              </div>
              
              <div className="bg-gradient-to-r from-purple-50 to-pink-50 rounded-lg sm:rounded-xl p-3 sm:p-4 lg:p-5 border border-purple-200 sm:col-span-2 lg:col-span-1">
                <div className="flex items-center mb-2 sm:mb-3">
                  <div className="bg-purple-500 rounded-full p-1.5 sm:p-2 mr-2 sm:mr-3">
                    <svg className="w-3 h-3 sm:w-4 sm:h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                    </svg>
                  </div>
                  <h3 className="text-xs sm:text-sm lg:text-base font-semibold text-purple-800">ການສະໜັບສະໜູນ</h3>
                </div>
                <p className="text-xs sm:text-sm text-purple-700">ຄູສອນພ້ອມສະໜັບສະໜູນທ່ານ</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Chat Popup */}
      <ChatPopup
        isOpen={isChatOpen}
        onClose={() => setIsChatOpen(false)}
      />
    </div>
  );
};

export default Chat;